import acpVirtualCardsInactiveErrorTemplate from './templates/acp-virtual-cards-inactive-error.html';

var acpVirtualCardsInactiveCards = {
  template: acpVirtualCardsInactiveErrorTemplate,
  bindings: {}, // bindings advice: https://docs.angularjs.org/guide/component#component-based-application-architecture
  require: {}
};

export default acpVirtualCardsInactiveCards;
